export default {"src":"/_next/static/media/hands-helping.f0192a12.svg","height":26,"width":26,"blurWidth":0,"blurHeight":0};